module.exports = __webpack_public_path__ + "static/media/clock still 04.0eea5e03.webp";